<template>
    <div id="wallet">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="section-heading heading-left">
                    <span class="subtitle primary bold">Cartera.</span>
                    <div class="row">
                        <div class="col-lg-12 mb--20">
                            <h3 class="font-weight-100">
                                Tras un proceso de mejora continua y más de 7 años de experiencia,
                                hemos desarrollado nuestro tercer modelo de riesgo crediticio
                                que ha dado resultados satisfactorios y consistentes.
                            </h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <ul class="nav nav-underline" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="home-tab" data-bs-toggle="tab"
                                        data-bs-target="#home-tab-pane" type="button" role="tab"
                                        aria-controls="home-tab-pane" aria-selected="true">Monto</a>
                                </li>
                                <!-- <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="profile-tab" data-bs-toggle="tab"
                                        data-bs-target="#profile-tab-pane" type="button" role="tab"
                                        aria-controls="profile-tab-pane" aria-selected="false">Créditos</a>
                                </li> -->
                            </ul>
                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel"
                                    aria-labelledby="home-tab" tabindex="0">
                                    <div id="anual" class="row mt-4">
                                        <div class="col-sm-6 col-md-3 col-lg-2 mb-3">
                                            <button @click.stop="selected = 0" class="btn btn-outline-primary p-3 bold" :class="selected == 0 ? 'active-btn' : ''">Acumulado</button>
                                        </div>
                                        <div class="col-sm-6 col-md-3 col-lg-2 mb-3">
                                            <button @click.stop="selected = 3" class="btn btn-outline-primary p-3 bold" :class="selected == 3 ? 'active-btn' : ''">Modelo 3</button>
                                        </div>
                                        <div class="col-sm-6 col-md-3 col-lg-2 mb-3">
                                            <button @click.stop="selected = 2" class="btn btn-outline-primary p-3 bold" :class="selected == 2 ? 'active-btn' : ''">Modelo 2</button>
                                        </div>
                                        <div class="col-sm-6 col-md-3 col-lg-2 mb-3">
                                            <button @click.stop="selected = 1" class="btn btn-outline-primary p-3 bold" :class="selected == 1 ? 'active-btn' : ''">Modelo 1</button>
                                        </div>
                                    </div>
                                    <div v-if="isMounted" class="row">
                                        <!-- A -->
                                        <template v-if="selected == 0">
                                            <div id="chart_A" class="col-sm-12 col-md-12 col-lg-5">
                                                <VueApexCharts v-if="isGraphReady" type="pie" width="480" :options="chartOptionsA"
                                                    :series="seriesA"></VueApexCharts>
                                            </div>
                                            <div class="col-sm-12 col-md-12 col-lg-6 mt-4">
                                                <div class="row">
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 primary">
                                                            {{ percentageA[0].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card primary-card">Pagado: {{ explicitMoneyFormat(seriesA[0], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 accent1">
                                                            {{ percentageA[1].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card accent1-card">Al corriente (0 a 29 días): {{ explicitMoneyFormat(seriesA[1], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 gray">
                                                            {{ percentageA[2].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card gray-card">Atraso (30 a 89 días): {{ explicitMoneyFormat(seriesA[2], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 black">
                                                            {{ percentageA[3].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card black-card">Vencido (+90 días): {{ explicitMoneyFormat(seriesA[3], 0) }}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- MODELO 1 -->
                                        <template v-if="selected == 1">
                                            <div id="chart_1" class="col-sm-12 col-md-12 col-lg-5">
                                                <VueApexCharts v-if="isGraphReady" type="pie" width="480" :options="chartOptions1"
                                                    :series="series1"></VueApexCharts>
                                            </div>
                                            <div class="col-sm-12 col-md-12 col-lg-6 mt-4">
                                                <div class="row">
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 primary">
                                                            {{ percentage1[0].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card primary-card">Pagado: {{ explicitMoneyFormat(series1[0], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 accent1">
                                                            {{ percentage1[1].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card accent1-card">Al corriente (0 a 29 días): {{ explicitMoneyFormat(series1[1], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 gray">
                                                            {{ percentage1[2].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card gray-card">Atraso (30 a 89 días): {{ explicitMoneyFormat(series1[2], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 black">
                                                            {{ percentage1[3].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card black-card">Vencido (+90 días): {{ explicitMoneyFormat(series1[3], 0) }}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- MODELO 2 -->
                                        <template v-if="selected == 2">
                                            <div id="chart_2" class="col-sm-12 col-md-12 col-lg-5">
                                                <VueApexCharts v-if="isGraphReady" type="pie" width="480" :options="chartOptions2"
                                                    :series="series2"></VueApexCharts>
                                            </div>
                                            <div class="col-sm-12 col-md-12 col-lg-6 mt-4">
                                                <div class="row">
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 primary">
                                                            {{ percentage2[0].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card primary-card">Pagado: {{ explicitMoneyFormat(series2[0], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 accent1">
                                                            {{ percentage2[1].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card accent1-card">Al corriente (0 a 29 días): {{ explicitMoneyFormat(series2[1], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 gray">
                                                            {{ percentage2[2].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card gray-card">Atraso (30 a 89 días): {{ explicitMoneyFormat(series2[2], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 black">
                                                            {{ percentage2[3].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card black-card">Vencido (+90 días): {{ explicitMoneyFormat(series2[3], 0) }}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- MODELO 3 -->
                                        <template v-if="selected == 3">
                                            <div id="chart_3" class="col-sm-12 col-md-12 col-lg-5">
                                                <VueApexCharts v-if="isGraphReady" type="pie" width="480" :options="chartOptions3"
                                                    :series="series3"></VueApexCharts>
                                            </div>
                                            <div class="col-sm-12 col-md-12 col-lg-6 mt-4">
                                                <div class="row">
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 primary">
                                                            {{ percentage3[0].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card primary-card">Pagado: {{ explicitMoneyFormat(series3[0], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 accent1">
                                                            {{ percentage3[1].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card accent1-card">Al corriente (0 a 29 días): {{ explicitMoneyFormat(series3[1], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 gray">
                                                            {{ percentage3[2].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card gray-card">Atraso (30 a 89 días): {{ explicitMoneyFormat(series3[2], 0) }}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h1 class="bold mb-0 black">
                                                            {{ percentage3[3].toFixed(1) }}%
                                                        </h1>
                                                        <h6 class="bold data-card black-card">Vencido (+90 días): {{ explicitMoneyFormat(series3[3], 0) }}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <!-- <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel"
                                    aria-labelledby="profile-tab" tabindex="0">
                                    <div id="acumulado" class="row">
                                        <div class="col-sm-12 col-md-10 col-lg-10">
                                            <div id="chart">

                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper.js";
import VueApexCharts from 'vue-apexcharts';
export default {
    name: "Wallet",
    props: ["rgStats", "isMounted"],
    mixins: [
        formatHelper
    ],
    components: {
        VueApexCharts
    },
    data: () => ({
        publicSiteDuePortfolio: null,
        isGraphReady: false,
        selected: 3,
        seriesA: [0,0,0,0],
        series1: [0,0,0,0],
        series2: [0,0,0,0],
        series3: [0,0,0,0],
        percentageA: [0,0,0,0],
        percentage1: [0,0,0,0],
        percentage2: [0,0,0,0],
        percentage3: [0,0,0,0],
        chartOptionsA: {
            chart: {
                width: 380,
                type: 'pie',
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                enabled: false
            },
            legend: {
                show: false
            },
            colors: ["#28DE18", "#CBFF00", "#999EAC", "#3B3A3E"],
            labels: ['Team A', 'Team B', 'Team C', 'Team D'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        show: false
                    },
                }
            }]
        },
        chartOptions1: {
            chart: {
                width: 380,
                type: 'pie',
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                enabled: false
            },
            legend: {
                show: false
            },
            colors: ["#28DE18", "#CBFF00", "#999EAC", "#3B3A3E"],
            labels: ['Team A', 'Team B', 'Team C', 'Team D'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        show: false
                    },
                }
            }]
        },
        chartOptions2: {
            chart: {
                width: 380,
                type: 'pie',
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                enabled: false
            },
            legend: {
                show: false
            },
            colors: ["#28DE18", "#CBFF00", "#999EAC", "#3B3A3E"],
            labels: ['Team A', 'Team B', 'Team C', 'Team D'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        show: false
                    },
                }
            }]
        },
        chartOptions3: {
            chart: {
                width: 380,
                type: 'pie',
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                enabled: false
            },
            legend: {
                show: false
            },
            colors: ["#28DE18", "#CBFF00", "#999EAC", "#3B3A3E"],
            labels: ['Team A', 'Team B', 'Team C', 'Team D'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        show: false
                    },
                }
            }]
        },
    }),
    mounted() {
        this.getStats();
    },
    methods: {
        getStats() {
            if(this.isMounted){
                const rg_stats = this.rgStats;
                this.publicSiteDuePortfolio = JSON.parse(rg_stats.public_site_due_portfolio);

                let accumulated = [0,0,0,0];
                this.series1 = [];
                this.series2 = [];
                this.series3 = [];
                this.seriesA = [];
                this.publicSiteDuePortfolio.duePortfolio.forEach(item => {                    
                    if(item.Modelo != null) {
                        let seriesName = null;
                        let percentageName = null;
                        if (item.Modelo == "Modelo 1") {
                            seriesName = "series1";
                            percentageName = "percentage1";
                        } else if (item.Modelo == "Modelo 2") {
                            seriesName = "series2";
                            percentageName = "percentage2";
                        } else if(item.Modelo == "Modelo 3.0" || item.Modelo == "Modelo 3.1") {
                            seriesName = "series3";
                            percentageName = "percentage3";
                        }

                        if(seriesName && percentageName) {
                            
                            accumulated[0] += item.Pagado;
                            accumulated[1] += item["Al corriente"];
                            accumulated[2] += item.Retrasado;
                            accumulated[3] += item.Vencido;

                            if(item.Modelo == "Modelo 3.1") {
                                this.series3[0] += item.Pagado;
                                this.series3[1] += item["Al corriente"];
                                this.series3[2] += item.Retrasado;
                                this.series3[3] += item.Vencido;
                            } else {
                                this[seriesName].push(item.Pagado);
                                this[seriesName].push(item["Al corriente"]);
                                this[seriesName].push(item.Retrasado);
                                this[seriesName].push(item.Vencido);
                            }

                            this[percentageName] = this.getPercentage(seriesName);
                        }
                    }

                });
                this.seriesA = accumulated;
                this.percentageA = this.getPercentage("seriesA");
                this.isGraphReady = true;
            }
        }, 
        getPercentage(serie){
            let sum = 0;
            this[serie].map(x => sum += x);
            let percentage = [];

            percentage[0] = (this[serie][0] * 100 ) / sum;
            percentage[1] = (this[serie][1] * 100 ) / sum;
            percentage[2] = (this[serie][2] * 100 ) / sum;
            percentage[3] = (this[serie][3] * 100 ) / sum;

            return percentage;
            
        }
    }
}
</script>

<style>
.btn-outline-primary {
    border-radius: 20px;
    width: 85%;
}

.btn-outline-primary:hover {
    color: var(--color-black);
}

#myTabContent {
    text-align: -webkit-center;
    text-align: center;
}

#chart_A {
    text-align: -webkit-center;
}

.data-card {
    padding: 0.7rem 0rem 0.7rem 0rem;
    margin-top: -21px;
}

.primary-card {
    border: solid var(--color-primary);
    background-color: var(--color-primary);
}
.accent1-card {
    border: solid var(--color-accent1);
    background-color: var(--color-accent1);    
}
.gray-card {
    border: solid var(--color-gray-5);
    background-color: var(--color-gray-5);    
}
.black-card {
    border: solid var(--color-black);
    background-color: var(--color-black); 
    color: var(--color-white);   
}

.active-btn {
    background-color: var(--color-primary);
    color: var(--color-white);
    border-color: var(--color-primary);
}

</style>